import { Component, Input } from '@angular/core';

@Component({
  selector: 'industries-footer',
  template: `
    <footer class="cta-section component-background">
      <h5 [ngClass]="text_color ? text_color : 'text-white-color'">{{ message }}</h5>
      <button *ngIf="buttonInfo" [routerLink]="buttonInfo.link" class="contact-btn component-background">
        {{ buttonInfo.name }}
      </button>
      <button *ngIf="!buttonInfo" routerLink="/contact" class="contact-btn component-background">
        Contact Us
      </button>
    </footer>
  `,
  styles: [
    `
      footer.cta-section {
        color: white;
        text-align: center;
        padding: 60px 10% 60px 10%; /*    top right bottom left */
      }
      footer h5 {
        /* color: white;  Removed to allow dynamic styling */
      }

      footer button {
        color: white;
        border: 1px solid white;
        padding: 10px 20px;
        cursor: pointer;
        border-radius: 5px;
        margin-top: 10px;
      }

      footer button:hover {
        background-color: #004d99;
      }
    `,
  ],
})
export class IndustriesFooterComponent {
  @Input('message') message: string | undefined;
  @Input('buttonInfo') buttonInfo: any;
  @Input('text_color') text_color: string = '';
}
